import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})
export class CustomdatePipe extends DatePipe implements PipeTransform {

  override transform(value: any, args?: any): any {
    if (value == null || isNaN(new Date(value).getTime())) {
      return ''; // Handle undefined fecModif
    }
    return super.transform(value, "dd/MM/yyyy");
  }
}
